import { AuthenticateWithRedirectCallback } from "@clerk/clerk-react";

/**
 * SSO callback page. Clerk's AuthenticateWithRedirectCallback handles:
 * - sign-in OAuth completion
 * - sign-up OAuth completion
 * - transfer flows (sign-up with existing email → auto-converts to sign-in)
 * - missing_requirements → redirects to signUpUrl (/register) for completion
 */
export default function AuthCallback() {
  return (
    <AuthenticateWithRedirectCallback
      signInForceRedirectUrl="/"
      signUpForceRedirectUrl="/"
      signInUrl="/login"
      signUpUrl="/register"
    />
  );
}
